import {useMutation, useQuery} from '@tanstack/react-query';
import {useSelector} from 'react-redux';
import {
  getProcSyncRecords,
  getProSyncRetryData,
  getProSyncSummaryData,
} from '../../../../../api/endpoints/ingestionApi';
import {IProcSyncRecordsRequest, IProcSyncRetryRequest} from '../../../../../api/types/ingestionApi.type';
import {RootState} from '../../../../../redux/store';

export const useProcSyncRecords = (payload: IProcSyncRecordsRequest) => {
  const projectId = useSelector(
    (state: RootState) => state.authenticatedUser.user?.projectId
  );

  return useQuery({
    queryKey: ['procSyncRecords', projectId, payload],
    queryFn: () => getProcSyncRecords(payload),
    staleTime: 0,
    enabled: !!projectId,
  });
};

export const useProcSyncSummary = () => {
  const projectId = useSelector(
    (state: RootState) => state.authenticatedUser.user?.projectId
  );

  return useQuery({
    queryKey: ['procSyncSummary', projectId],
    queryFn: () => getProSyncSummaryData(),
    staleTime: 0,
    enabled: !!projectId,
  });
};

export const useProcSyncRetry = () => {
  return useMutation({
    mutationFn: (payload: IProcSyncRetryRequest) =>
      getProSyncRetryData(payload),
  });
};